import {
  ErrorHandler,
  Inject,
  Injectable,
  InjectionToken,
} from '@angular/core';

const WINDOW = new InjectionToken<Window>('Browser window injection token', {
  factory: () => window,
});

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(@Inject(WINDOW) private window: Window) {}

  handleError(error: any): void {
    const chunkFailedMessage = /Failed to fetch dynamically imported module/;

    if (chunkFailedMessage.test(error.message)) {
      this.window.location.reload();
    }
  }
}
